import { render, staticRenderFns } from "./Scrollbar.vue?vue&type=template&id=75ca3b65&"
import script from "./Scrollbar.vue?vue&type=script&lang=js&"
export * from "./Scrollbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports